<template>
    <b-modal id="modal-edit-tarefa" title="Tarefa" no-fade no-close-on-backdrop no-close-on-esc @show="onShow()">
        <b-form-row>
            <b-col>
                <b-form-group label="Descrição" label-size="sm">
                    <b-form-textarea
                        rows="3"
                        no-resize
                        size="sm"
                        maxlength="255"
                        v-model="registro.descricao"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col>
                <b-form-group label="Data de Início" label-size="sm" label-for="dt_inicio">
                    <date-picker
                        input-class="form-control form-control-sm"
                        :clearable="false"
                        maxlength="10"
                        format="DD/MM/YYYY"
                        value-type="YYYY-MM-DD"
                        @change="doChangeInicio"
                        v-model="registro.dt_inicio"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="Data de Término" label-size="sm" label-for="dt_termino">
                    <date-picker
                        id="dt_termino"
                        input-class="form-control form-control-sm"
                        :clearable="false"
                        maxlength="10"
                        format="DD/MM/YYYY"
                        value-type="YYYY-MM-DD"
                        @change="doChangeTermino"
                        v-model="registro.dt_termino"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="Duração (dias)" label-size="sm" label-for="duracao">
                    <b-form-input @change="doChangeDuracao" id="duracao" size="sm" v-model="registro.duracao">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col>
                <b-form-group label="Predecessora" label-size="sm" label-for="predecessora_id">
                    <b-form-select
                        id="predecessora_id"
                        size="sm"
                        v-model="registro.predecessora_id"
                        :options="tarefas"
                        value-field="registro_id"
                        text-field="descricao"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col>
                <b-form-group label="Status" label-size="sm" label-for="status_id">
                    <b-form-select size="sm" v-model="registro.status_id">
                        <b-form-select-option value="1">Ativo</b-form-select-option>
                        <b-form-select-option value="2">Suspenso</b-form-select-option>
                        <b-form-select-option value="3">Concluído</b-form-select-option>
                        <b-form-select-option value="4">Atrasado</b-form-select-option>
                        <b-form-select-option value="5">Indefinido</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col sm="12" md="12" lg="12">
                <b-form-group label="Controle da Tarefa" label-size="sm" label-for="controle_id">
                    <b-form-select id="controle_id" name="controle_id" size="sm" v-model="registro.controle_id">
                        <b-form-select-option value="">Sem Controle</b-form-select-option>
                        <b-form-select-option value="CHAMAMENTO_PUBLICO"
                            >Licitação - Dt Chamamento Público</b-form-select-option
                        >
                        <b-form-select-option value="ENTREGA_MI">Licitação - Dt Entrega da MI</b-form-select-option>
                        <b-form-select-option value="CBR1_DATA"
                            >Licitação - 1ª Não Objeção - Dt CBR</b-form-select-option
                        >
                        <b-form-select-option value="PUBLIC_LICITACAO">Licitação - Dt Publicação</b-form-select-option>
                        <b-form-select-option value="ABERT_LICITACAO">Licitação - Dt Abertura</b-form-select-option>
                        <b-form-select-option value="CBR2_DATA"
                            >Licitação - 2ª Não Objeção - Dt CBR</b-form-select-option
                        >
                        <b-form-select-option value="PROPOSTA_PRECO"
                            >Licitação - Dt Proposta Preços</b-form-select-option
                        >
                        <b-form-select-option value="REUNIAO_NEGOC"
                            >Licitação - Dt Reunião Negociação</b-form-select-option
                        >
                        <b-form-select-option value="CBR3_DATA"
                            >Licitação - 3ª Não Objeção - Dt CBR</b-form-select-option
                        >
                        <b-form-select-option value="ASSINATURA_CONTRATO"
                            >Contrato - Dt Assinatura Contrato</b-form-select-option
                        >
                        <b-form-select-option value="OS">Contrato - Dt OS</b-form-select-option>
                        <b-form-select-option value="DATA_FINAL">Cálculo - Dt Final</b-form-select-option>
                        <b-form-select-option value="DATA_INICIAL">Marco - Dt Inicial</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-form-row>
        <template v-slot:modal-footer>
            <b-button size="sm" @click="doSaveTarefa" variant="primary"> <i class="fas fa-check"></i> Gravar </b-button>
            <b-button size="sm" @click="() => $bvModal.hide('modal-edit-tarefa')">Cancelar</b-button>
        </template>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

import axios from "axios";
import { baseApiUrl, showError } from "@/global";
import moment from "moment";
import Vue from "vue";
import { validateDate } from "../../../global";

export default {
    name: "ModalEditTarefa",
    components: { DatePicker },
    props: {
        wbs: { type: Object, required: true },
        registro: { type: Object, required: true },
        acao: { type: String, required: true },
    },
    data: function() {
        return {
            tarefas: [],
        };
    },
    methods: {
        doCalcDuracao() {
            let _dtini = moment(this.registro.dt_inicio, "YYYY-MM-DD");
            let _dtfim = moment(this.registro.dt_termino, "YYYY-MM-DD");
            this.registro.duracao = moment(_dtfim).diff(_dtini, "days");
        },
        doChangeDuracao() {
            let _dtini = moment(this.registro.dt_inicio, "YYYY-MM-DD");
            this.doChangeTermino(_dtini.add(this.registro.duracao, "days").format("YYYY-MM-DD"));
        },
        doChangeInicio(date) {
            this.registro.dt_inicio = date;
            Vue.set(this.registro, "dt_inicio", date);

            this.doCalcDuracao();
        },
        doChangeTermino(date) {
            this.registro.dt_termino = date;
            Vue.set(this.registro, "dt_termino", date);
            this.doCalcDuracao();
        },
        doSaveTarefa() {
            let _msg = "";

            if ((this.registro.descricao || "") === "") _msg += (_msg !== "" ? "<br/>" : "") + "Digite a Descrição!";

            if (!validateDate(this.registro.dt_inicio, "YYYY-MM-DD"))
                _msg += (_msg !== "" ? "<br/>" : "") + "Data de Início Inválida";

            if (!validateDate(this.registro.dt_termino, "YYYY-MM-DD"))
                _msg += (_msg !== "" ? "<br/>" : "") + "Data de Término Inválida";

            let _dtIni = moment(this.registro.dt_inicio, "YYYY-MM-DD");
            let _dtFim = moment(this.registro.dt_termino, "YYYY-MM-DD");

            if (_dtFim.isBefore(_dtIni)) _msg += (_msg !== "" ? "<br/>" : "") + "Data de Término Inválida!";

            if (_msg !== "") {
                this.$toasted.info(_msg, {
                    duration: 4000,
                    keepOnHover: true,
                    className: "v-toasted-warning",
                });
                return false;
            }

            this.registro.programa_id = this.wbs.programa_id;
            this.registro.wbs_id = this.wbs.wbs_id;
            let _saveObj = { ...this.registro };
            //_saveObj.predecessora = "" + _saveObj.predecessora;
            if (this.acao === "incluir") {
                axios
                    .post(`${baseApiUrl}/bid/cronograma`, _saveObj)
                    .then(() => {
                        this.$emit("updatedCronograma", "");
                        this.$bvModal.hide("modal-edit-tarefa");
                    })
                    .catch(showError);
            } else {
                axios
                    .put(`${baseApiUrl}/bid/cronograma/${this.registro.registro_id}`, _saveObj)
                    .then(() => {
                        this.$emit("updatedCronograma", "");
                        this.$bvModal.hide("modal-edit-tarefa");
                    })
                    .catch(showError);
            }
        },
        onShow() {
            console.log(this.registro);
            axios
                .get(`${baseApiUrl}/bid/cronograma/listar`, {
                    params: {
                        programa_id: this.wbs.programa_id,
                        wbs_id: this.wbs.wbs_id,
                    },
                })
                .then((resp) => {
                    this.tarefas = resp.data;
                    this.tarefas.unshift({ registro_id: 0, descricao: "" });
                    this.doCalcDuracao();
                })
                .catch((err) => {
                    console.log(err);
                    showError(err);
                });
        },
    },
};
</script>

<style></style>
